import Confirmation from "../Modal/Confirmation";
import useCategoryHook from "@/shared/hooks/useCategoryHook";
import { useModalMeta } from "@/shared/atoms/useModal";
import { ModalProps } from "../Modal/Modal";
import { MenuItems } from "@/shared/utils/enum";

const MenuConfirmationModal = ({ onExit, ...props }: ModalProps) => {
  const [{ type, data }] = useModalMeta();

  const { categoryRemove, productRemove, categoryUpdate, productUpdate } =
    useCategoryHook();

  const handleRemove = () => {
    const { item_id, item_type } = data;

    if (type === MenuItems.CATEGORY) {
      categoryRemove.mutateAsync(item_id, { onSuccess: () => onExit() });
    } else if (type === MenuItems.PRODUCT) {
      productRemove.mutateAsync(item_id, { onSuccess: () => onExit() });
    } else if (type === "image") {
      if (item_type === MenuItems.CATEGORY) {
        categoryUpdate.mutateAsync(
          { ...data, image_cloudinary_id: "" },
          {
            onSuccess: () => onExit(),
          }
        );
      } else if (item_type === MenuItems.PRODUCT) {
        productUpdate.mutateAsync(
          { ...data, image_cloudinary_id: "" },
          {
            onSuccess: () => onExit(),
          }
        );
      }
    }
  };

  return (
    <Confirmation
      isPending={
        categoryRemove.isPending ||
        productRemove.isPending ||
        categoryUpdate.isPending ||
        productUpdate.isPending
      }
      onSuccess={handleRemove}
      show={true}
      onExit={() => onExit()}
    />
  );
};

export default MenuConfirmationModal;
